"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FontAwesomeIcon = _interopRequireDefault(require("../FontAwesomeIcon/FontAwesomeIcon"));

var _DropdownButtonIconModule = _interopRequireDefault(require("./DropdownButtonIcon.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var propTypes = {
  icon: _propTypes.default.object.isRequired,
  label: _propTypes.default.string.isRequired,
  className: _propTypes.default.string
};
var defaultProps = {
  className: ''
};

var DropdownButtonIcon = function DropdownButtonIcon(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      className = _ref.className;
  var iconClassName = (0, _classnames.default)(_DropdownButtonIconModule.default.icon, className);
  return _react.default.createElement("span", {
    className: _DropdownButtonIconModule.default.icon_container
  }, _react.default.createElement(_FontAwesomeIcon.default, {
    title: label,
    icon: icon,
    className: iconClassName
  }));
};

DropdownButtonIcon.propTypes = propTypes;
DropdownButtonIcon.defaultProps = defaultProps;

var _default = (0, _react.memo)(DropdownButtonIcon);

exports.default = _default;